import React, { useEffect, useState } from 'react'
import Pieneedlechart from './repeatneedle';
import Areachart from './repaetareachartBlue';
import livechaticon from './images/livechaticon.png'
import clockimg from './images/clockimg.png'
import profileimg from './images/img.png'
import arrowup from './images/arrowup.png'
import arrowupred from './images/arrowupred.png'
import usericon from './images/usericon.png'
import downloadicon from './images/downloadicon.png'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import ReactApexChart from "react-apexcharts";
import { getRepeatEmployee, getPerformanceDataGraphApiRepeat, getSoftApprovalCommentsApiRepeat,  downloadOperationData,  getHourswiseDataApi, getPerformanceDataAPiNewNew, getHourswiseDataNewApi, getEmployeeLeadActivity, getLeadProgressSummaryForEmployeeById, getLeadProgressDataForEmployeeById } from './actioncreator';
import { getStartDateOfPreviousSevenDays, reverseFormat, todayDate } from '../../../../../utils/commonUtility';
// import Loader from '../../../../presentationals/Loader/dots'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { Eye, Calendar } from 'lucide-react';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import DateFilter from './DateFilter';
import './DateFilter.scss';
import D3TreeFlowchart from './D3TreeFlowchart';
import './D3TreeFlowchart.css';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NoData from '../../../../../images/nodata.png'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import styled from "@emotion/styled";
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../../reducers/CommonFilters.reducer';

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: '12px', // Adjust the font size as needed
        boxShadow: '3px 3px 10px 2px #ccc',
        background: '#fff',
        color: '#000'
    },
}));

function PerformanceDashboard() {
    const dispatch = useDispatch();
    const { fromDate: ReducerFrom, toDate: ReducerTo } = useSelector(state => state.FilterReduce.commonFilters);

    const [fromdate, setfromdate] = useState(moment(ReducerFrom).format("DD-MM-YYYY"));
    const [todate, settodate] = useState(moment(ReducerTo).format("DD-MM-YYYY"));
    const [filtertype, setfiltertype] = useState('last7days');
    const [reconcilemodal, setreconcilemodal] = useState(false);
    const [popuplabeltype, setpopuplabeltype] = useState('');
    const [page, setpage] = useState(1);
    const [size, setsize] = useState(100);
    const [operationEmployees, setOperationEmployees] = useState([]);
    const [perfomanceData, setPeformanceData] = useState([]);
    const [emailId, setEmailId] = useState('');
    const [loaderState, setloaderState] = useState(false);
    const [areachartData, setareachartData] = useState('');
    const [softApprovalData, setSoftApprovalData] = useState([]);
    const [nameComment, setNameComments] = useState([]);
    const [dataComment, setDataComments] = useState([]);
    const [employeeData, setEmployeeData] = useState('');
    const [performanceLoader, setPerformanceGraphLoader] = useState('');
    const [commentLoader, setCommentLoader] = useState('');
    const [dashboardData, setSmallDashboardData] = useState({});
    const [tabularData, setTabularData] = useState('');
    const [process, setProcess] = useState('');
    const [downloadLoader, setloaderStateDownload] = useState(false);
    const [graphData, setData] = useState('');
    const [hoursWiseData, setDataHours] = useState('');
    const [selectedDate, setDate] = useState('');
    const [SelectedHourwiseFilter, setSelectedHourwiseFilter] = useState("timeframe");
    const [selectedDateHourwise, setselectedDateHourwise] = useState("");
    const [chartViewType, setChartViewType] = useState('funnel'); // 'funnel' or 'flowchart'
    const [selectedDateWisePopup, setselectedDateWisePopup] = useState({ show: false, valueDate: "", data: {} })
    const [tabledataDate, setTableDataDatewise] = useState([]);
    const [state, setState] = useState({
        series: [
            {
                name: 'Touched',
                data: [],
            },
            {
                name: 'Completed',
                data: [
                ],
            },
        ],
        options: {
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        total: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900,
                            },
                        },
                    },
                },
            },
            stroke: {
                width: 1,
                colors: ['#fff'],
            },
            title: {
                text: '',
            },
            xaxis: {
                categories: [
                ],
                labels: {
                    formatter: function (val) {
                        // console.log(val)

                        // Optional: You can customize this format if needed
                        return val;
                    },
                },
            },
            yaxis: {
                title: {
                    text: '',
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + " Tasks";
                    },
                },
            },
            fill: {
                opacity: 1,
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left',
                offsetX: 40,
            },
        },
    });


    useEffect(() => {
        setfromdate(moment(ReducerFrom).format("DD-MM-YYYY"))
        settodate(moment(ReducerTo).format("DD-MM-YYYY"))
         getemployees()
    }, [ReducerFrom, ReducerTo])



    const handleChange = (name, value) => {
        // Handle direct calls from DateFilter
        if (typeof name === 'string' && typeof value === 'string') {
            if (name === "fromDate") {
                setfromdate(value);
            } else {
                settodate(value);
            }
        } else if (arguments[0] && arguments[0].target) {
            // Handle traditional form events
            const e = arguments[0];
            if (e.target.name === "fromDate") {
                setfromdate((reverseFormat(e.target.value)));
            } else {
                settodate((reverseFormat(e.target.value)));
            }
        }
    };
    const handleReset = () => {
        // Reset to today's date
        const today = moment().format('DD-MM-YYYY');
        setfromdate(today);
        settodate(today);

        // Apply filter with today's date - pass the dates directly
        applyfilter({ from: today, to: today });
    };
    const DowloadReport = () => {
        setloaderStateDownload(true)
        downloadOperationData(fromdate, todate, emailId, process, callback => {
            setloaderStateDownload(false)

        })

    }
    const applyfilter = ({ from, to } = {}) => {
        setSelectedHourwiseFilter("timeframe")
        setselectedDateHourwise("")
        setloaderState(true)

        // ✅ Use 'from' and 'to' directly from DateFilter - no fallback to old state
        const startDate = from;
        const endDate = to;

        // ✅ Update state for display
        setfromdate(from);
        settodate(to);
        
        dispatch({
            type: FILTER_ACTION, payload: {
                fromDate: moment(from, "DD-MM-YYYY").format("YYYY-MM-DD"),
                toDate: moment(to, "DD-MM-YYYY").format("YYYY-MM-DD")
            }
        });

        // getPerformanceDataApiRepeat(startDate, endDate, emailId, callback => {
        //     setPeformanceData(callback?.data)
        //     setSmallDashboardData(callback?.performanceResp)
        //     setloaderState(false)
        // })
        getLeadProgressSummaryForEmployeeById(startDate, endDate, emailId, callback => {
            setPeformanceData(callback)
            setSmallDashboardData(callback?.performanceResp)
            setloaderState(false)
        })
        setPerformanceGraphLoader(true)
        getPerformanceDataGraphApiRepeat(startDate, endDate, emailId, callback => {
            setareachartData(callback.perfAnalysis)
            setPerformanceGraphLoader(false)


        })
        setCommentLoader(true)
        getSoftApprovalCommentsApiRepeat(startDate, endDate, emailId, callback => {
            setSoftApprovalData(callback.commentStats)
            makegraphDataOpportunity(callback.commentStats)
            setCommentLoader(false)


        })
        getPerformanceDataAPiNewNew(emailId, startDate, endDate, callback => {
            setTableDataDatewise((callback && callback.data) || [])
            const formattedData = (callback && callback.data || []).map((item) => {

                const dateParts = item.date.split('-');
                const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
                return {
                    x: [
                        `Today:`,
                        `completed: ${item.today.completed}`,
                        `pending: ${item.today.pending}`,
                        `totalAssigned: ${item.today.assigned}`,
                        `touched: ${item.today.touched}`,
                        `unTouched: ${item.today.untouched}`,
                        `Backlog:`,
                        `completed: ${item?.backlog?.completed}`,
                        `pending: ${item?.backlog?.pending}`,
                        `totalAssigned: ${item?.backlog?.assigned}`,
                        `touched: ${item?.backlog?.touched}`,
                        `unTouched: ${item?.backlog?.untouched}`,
                    ],
                    y: [
                        formattedDate.getTime(),
                        formattedDate.getTime() + 86400000,
                    ],
                    fillColor: '#607d8b',
                };
            });



            setData(formattedData);

        })

    }
    const applyfilterNew = (start, end) => {
        setloaderState(true)

        // Validate dates before making API calls
        if (!start || !end) {
            console.error('Invalid date range: start or end is missing');
            setloaderState(false);
            return;
        }

        try {
            getLeadProgressSummaryForEmployeeById(start, end, emailId, callback => {
                if (callback && callback.data) {
                    setPeformanceData(callback)
                    setSmallDashboardData(callback?.performanceResp)
                } else {
                    console.error('Invalid API response for lead progress data');
                }
                setloaderState(false)
            })
            setPerformanceGraphLoader(true)
            getPerformanceDataGraphApiRepeat(start, end, emailId, callback => {
                if (callback && callback.perfAnalysis) {
                    setareachartData(callback.perfAnalysis)
                } else {
                    console.error('Invalid API response for graph data');
                }
                setPerformanceGraphLoader(false)
            })
            setCommentLoader(true)
            getSoftApprovalCommentsApiRepeat(start, end, emailId, callback => {
                if (callback && callback.commentStats) {
                    setSoftApprovalData(callback.commentStats)
                    makegraphDataOpportunity(callback.commentStats)
                } else {
                    console.error('Invalid API response for comment data');
                }
                setCommentLoader(false)
            })
            getPerformanceDataAPiNewNew(emailId, start, end, callback => {
                if (callback && callback.data) {
                    setTableDataDatewise(callback.data || [])
                    const formattedData = (callback.data || []).map((item) => {
                        const dateParts = item.date.split('-');
                        const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
                        return {
                            x: [
                                `completed: ${item.completed}`,
                                `pending: ${item.pending}`,
                                `totalAssigned: ${item.assigned}`,
                                `touched: ${item.touched}`,
                                `unTouched: ${item.untouched}`,
                                `Backlog:`,
                                `completed: ${item?.backlog?.completed}`,
                                `pending: ${item?.backlog?.pending}`,
                                `totalAssigned: ${item?.backlog?.assigned}`,
                                `touched: ${item?.backlog?.touched}`,
                                `unTouched: ${item?.backlog?.untouched}`,
                            ],
                            y: [
                                formattedDate.getTime(),
                                formattedDate.getTime() + 86400000,
                            ],
                            fillColor: '#607d8b',
                        };
                    });
                    setData(formattedData);
                } else {
                    console.error('Invalid API response for table data');
                }
            })
        } catch (error) {
            console.error('Error applying filter:', error);
            setloaderState(false);
            setPerformanceGraphLoader(false);
            setCommentLoader(false);
        }
    }
    const handlefilter = (e) => {
        setSelectedHourwiseFilter("timeframe")
        setselectedDateHourwise("")
        const selectedValue = e && e.target && e.target.value !== undefined ? e.target.value : e;

        // Calculate date range based on selected filter
        const endDate = moment();
        let startDate;

        switch (selectedValue) {
            case 'last7days':
                startDate = moment().subtract(7, 'days');
                break;
            case 'lastmonth':
                startDate = moment().subtract(1, 'months');
                break;
            case 'last2month':
                startDate = moment().subtract(2, 'months');
                break;
            case 'last3month':
                startDate = moment().subtract(3, 'months');
                break;
            case 'last6month':
                startDate = moment().subtract(6, 'months');
                break;
            case 'lastyear':
                startDate = moment().subtract(1, 'years');
                break;
            default:
                return;
        }

        const formattedStart = startDate.format('DD-MM-YYYY');
        const formattedEnd = endDate.format('DD-MM-YYYY');

        // Update the date states
        setfromdate(formattedStart);
        settodate(formattedEnd);

        // Apply the filter
        applyfilterNewManual(formattedStart, formattedEnd);
    };
    const applyfilterNewManual = (start, end) => {
        setloaderState(true)

        // Validate dates before making API calls
        if (!start || !end) {
            console.error('Invalid date range: start or end is missing');
            setloaderState(false);
            return;
        }

        try {
            getLeadProgressSummaryForEmployeeById(start, end, emailId, callback => {
                if (callback && callback.data) {
                    setPeformanceData(callback)
                    setSmallDashboardData(callback?.performanceResp)
                } else {
                    console.error('Invalid API response for lead progress data');
                }
                setloaderState(false)
            })
            setPerformanceGraphLoader(true)
            getPerformanceDataGraphApiRepeat(start, end, emailId, callback => {
                if (callback && callback.perfAnalysis) {
                    setareachartData(callback.perfAnalysis)
                } else {
                    console.error('Invalid API response for graph data');
                }
                setPerformanceGraphLoader(false)
            })
            setCommentLoader(true)
            getSoftApprovalCommentsApiRepeat(start, end, emailId, callback => {
                if (callback && callback.commentStats) {
                    setSoftApprovalData(callback.commentStats)
                    makegraphDataOpportunity(callback.commentStats)
                } else {
                    console.error('Invalid API response for comment data');
                }
                setCommentLoader(false)
            })
            getPerformanceDataAPiNewNew(emailId, start, end, callback => {
                if (callback && callback.data) {
                    setTableDataDatewise(callback.data || [])
                    const formattedData = (callback.data || []).map((item) => {
                        const dateParts = item.date.split('-');
                        const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
                        return {
                            x: [
                                `completed: ${item.completed}`,
                                `pending: ${item.pending}`,
                                `totalAssigned: ${item.assigned}`,
                                `touched: ${item.touched}`,
                                `unTouched: ${item.untouched}`,
                                `Backlog:`,
                                `completed: ${item?.backlog?.completed}`,
                                `pending: ${item?.backlog?.pending}`,
                                `totalAssigned: ${item?.backlog?.assigned}`,
                                `touched: ${item?.backlog?.touched}`,
                                `unTouched: ${item?.backlog?.untouched}`,
                            ],
                            y: [
                                formattedDate.getTime(),
                                formattedDate.getTime() + 86400000,
                            ],
                            fillColor: '#607d8b',
                        };
                    });
                    setData(formattedData);
                } else {
                    console.error('Invalid API response for table data');
                }
            })
        } catch (error) {
            console.error('Error applying filter:', error);
            setloaderState(false);
            setPerformanceGraphLoader(false);
            setCommentLoader(false);
        }
    }
    const sortedData = {
        "Category 1": 700,
        "Category 2": 500,
        "Category 3": 400,
        "Category 4": 300,
        "Category 5": 200
    };
    const sortedData3 = dataComment;
    sortedData3.sort((a, b) => b - a);
    const nameOpportunity = Object.keys(nameComment);

    var options = {
        series: [{
            data: Object.values(sortedData3),
        }],
        chart: {
            type: 'bar',
            height: 270,
        },

        plotOptions: {
            bar: {
                borderRadius: 0,
                horizontal: true,
                barHeight: '90%',
                isFunnel: true,
                borderRadius: 1,
                orientation: 'vertical',
                radius: 2,
                enableShades: true,
                shadeIntensity: 0.9,
                reverseNegativeShade: true,
                distributed: true,
                useFillColorAsStroke: false,


                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 0,
                        color: undefined,
                        foreColor: undefined,
                        name: undefined,
                    }],
                    inverse: false,
                    min: undefined,
                    max: undefined
                },


            },
        },
        colors: ['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC'],
        fill: {
            colors: ['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC'],
            opacity: 0.3,
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: "vertical",
                shadeIntensity: 1.8,
                gradientToColors: false,
                inverseColors: false,
                opacityFrom: 0.9,
                opacityTo: 1,
                colorStops: []
            },
        }, dataLabels: {
            enabled: true,
            formatter: function (val, opt) {
                const opportunityName = nameOpportunity[opt.dataPointIndex];
                return val;
            },

            dropShadow: {
                enabled: true,
            },
        },
        xaxis: {
            categories: nameComment,
        },
        legend: {
            position: 'right',
            show: false,
            markers: {
                fillColors: ['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC'],
            },
        },


    };


    let data = [
        // { label: 'Total Assigned Leads', percentage: 100 },
        // { label: 'Soft Follow up', percentage: 80 },
        // { label: 'Quality Check Done', percentage: 50 },
        // { label: 'E-sign/E-mandate', percentage: 40 },
        // { label: 'Reference Verified', percentage: 30 },
        // { label: 'Auto/Manual RFD', percentage: 20 },
        // { label: 'Pending Leads', percentage: 10 },
        // { label: 'Expired Leads', percentage: 5 },
    ];

    let b = "20%";
    let c = "80%";


    const handlefunnelgraphpopup = (label, process) => {

        setpopuplabeltype(label);
        setProcess(process)
        setloaderState(true)
        // getOperationTabularDataApiRepeat(fromdate, todate, emailId, process, callback => {
        //     setTabularData(callback)
        //     setreconcilemodal(true);
        //     setloaderState(false)


        // })
        getLeadProgressDataForEmployeeById(fromdate, todate, emailId, process, callback => {
            setTabularData(callback)
            setreconcilemodal(true);
            setloaderState(false)


        })
    }

    const handleChartViewChange = (event, newView) => {
        if (newView !== null) {
            setChartViewType(newView);
        }
    };
    const getemployees = () => {
        setloaderState(true)
        getRepeatEmployee(page, size, callback => {
            setOperationEmployees(callback)
            setloaderState(false)
            getPerformanceData(callback.teamMembers[0])
            getEmpDashboardSata(callback.teamMembers[0].emailId)


        })
    }
    const getEmpDashboardSata = (data) => {

    }

    const optionnews = {
        items: 3,
        loop: true,
        autoplay: true,
        // nav: true,
        // dots:true
    };

    const items = operationEmployees && operationEmployees.teamMembers
        ? operationEmployees.teamMembers.map((data, i) => (
            <div key={i + 1} className="itemcard" onClick={() => getPerformanceData(data)}>
                <div className="subcard">
                    <img className="imgbox" src={profileimg} alt="" />
                    <h4 className='h4'>{data.name} </h4>
                    <h6 className='h6'>{data.profile}</h6>
                </div>
            </div>
        ))
        : [];
    const getPerformanceData = (data) => {
        setEmployeeData(data)
        setEmailId(data.emailId)
        setloaderState(true)
        getLeadProgressSummaryForEmployeeById(fromdate, todate, data.emailId, callback => {
            setPeformanceData(callback)
            setSmallDashboardData(callback?.performanceResp)
            setloaderState(false)

        })


        setPerformanceGraphLoader(true)
        getPerformanceDataGraphApiRepeat(fromdate, todate, data.emailId, callback => {
            setareachartData(callback.perfAnalysis)
            setPerformanceGraphLoader(false)
        })
        setCommentLoader(true)
        getSoftApprovalCommentsApiRepeat(fromdate, todate, data.emailId, callback => {
            setSoftApprovalData(callback.commentStats)
            makegraphDataOpportunity(callback.commentStats)
            setCommentLoader(false)
        })
        getPerformanceDataAPiNewNew(data.emailId, fromdate, todate, callback => {
            setTableDataDatewise((callback && callback.data) || [])

            const formattedData = (callback && callback.data || []).map((item) => {

                const dateParts = item.date.split('-');
                const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
                return {
                    x: [
                        `Today:`,
                        `completed: ${item.today.completed}`,
                        `pending: ${item.today.pending}`,
                        `totalAssigned: ${item.today.assigned}`,
                        `touched: ${item.today.touched}`,
                        `unTouched: ${item.today.untouched}`,
                        `Backlog:`,
                        `completed: ${item?.backlog?.completed}`,
                        `pending: ${item?.backlog?.pending}`,
                        `totalAssigned: ${item?.backlog?.assigned}`,
                        `touched: ${item?.backlog?.touched}`,
                        `unTouched: ${item?.backlog?.untouched}`,
                    ],
                    y: [
                        formattedDate.getTime(),
                        formattedDate.getTime() + 86400000,
                    ],
                    fillColor: '#607d8b',
                };
            });



            setData(formattedData);

        })
    }
    const makegraphDataOpportunity = (To) => {
        let name = [];
        let data = [];
        let hb = [{
            "count": 1,
            "label": "QC Done"
        }, {
            "count": 100,
            "label": "QC Done"
        },
        {
            "count": 10,
            "label": "QC Done"
        },
        {
            "count": 50,
            "label": "QC Done"
        }

        ]

        for (const item of To) {
            const { count, label, } = item;

            name.push(label);

            data.push(count);
        }

        setNameComments(name);
        setDataComments(data);

    }
    const sortedData1 = perfomanceData && perfomanceData?.length > 0 ? [...perfomanceData].sort((b, a) => a.value - b.value) : [];





    const dategraph2 = {
        series: [
            {
                data: graphData,
            },
        ],
        chart: {
            height: 350,
            type: 'rangeBar',
            events: {
                dataPointSelection: function (event, chartContext, config) {

                    const dataPointIndex = config.dataPointIndex;

                    const selectedPointFromGraphData = graphData[dataPointIndex];

                    if (selectedPointFromGraphData) {

                        const startDate = moment(selectedPointFromGraphData.y[0]);
                        const endDate = moment(selectedPointFromGraphData[1]);

                        const dataForApi = {
                            startDate: startDate.format('DD-MM-YYYY'),
                            endDate: endDate.format('YYYY-MM-DD'),
                        };

                        setselectedDateHourwise(dataForApi.startDate)
                        sendDATA(dataForApi.startDate, SelectedHourwiseFilter)


                    } else {
                    }
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                distributed: true,
                dataLabels: {
                    hideOverflowingLabels: false,
                },
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                const label = opts?.w?.globals?.labels?.[opts?.dataPointIndex]?.[0];

                return label
            },
            style: {
                colors: ['#f3f4f5', '#fff'],
            },
        },
        xaxis: {
            type: 'datetime',
        },
        yaxis: {
            show: false,
        },
        grid: {
            row: {
                colors: ['#f3f4f5', '#fff'],
                opacity: 1,
            },
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                // console.log("ser", seriesIndex, dataPointIndex, graphData[seriesIndex])
                const data = graphData[seriesIndex];
                if (!data) return 'No data';

                const lines = data?.x.map(val => `<div>${val}</div>`).join('');
                const start = moment(data.y[0]).format("YYYY-MM-DD");
                const end = moment(data.y[1]).format("YYYY-MM-DD");

                return `
                                <div style="padding: 10px;">
                                    <strong>Start:</strong> ${start}<br/>
                                    <strong>End:</strong> ${end}<br/>
                                    <div style="margin-top: 5px;"><strong>Details:</strong><br/>${lines}</div>
                                </div>
                            `;
            },
        },
    };

    const sendDATA = (data, type) => {
        setDate(data)
        getHourswiseDataApi(emailId, data, callback => {
            setDataHours(callback.data);
            const touchedData = callback?.data?.map(item => ({
                x: item?.date,
                y: item?.[type]?.touched,
            }));

            const completedData = callback?.data?.map(item => ({
                x: item?.date,
                y: item?.[type]?.completed,
            }));

            const totalAssignedData = callback?.data?.map(item => ({
                x: item?.date,
                y: item?.[type]?.assigned,
            }));
            const totalAssignedAtThatHourData = callback?.data?.map(item => ({
                x: item?.date,
                y: item?.assignedAtThatHour,
            }));

            const pendingData = callback?.data?.map(item => ({
                x: item?.date,
                y: item?.[type]?.pending,
            }));

            const unTouchedData = callback?.data?.map(item => ({
                x: item?.date,
                y: item?.[type]?.untouched,
            }));

            setState(prevState => ({
                ...prevState,
                series: [
                    {
                        name: 'Total Assigned At That Hour',
                        data: totalAssignedAtThatHourData,
                    },
                    {
                        name: 'Touched',
                        data: touchedData,
                    },
                    {
                        name: 'UnTouched',
                        data: unTouchedData,
                    },
                    {
                        name: 'Completed',
                        data: completedData,
                    },
                    {
                        name: 'Pending',
                        data: pendingData,
                    },
                ],
                options: {
                    ...prevState.options,
                    xaxis: {
                        ...prevState.options.xaxis,
                        categories: callback.data.map(item => (item.date).split(' ')[1]),
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                total: {
                                    enabled: true,
                                    offsetX: 0,
                                    style: {
                                        fontSize: '13px',
                                        fontWeight: 900,
                                    },
                                    formatter: function (totalValue, options) {
                                        const index = options.dataPointIndex;

                                        const customTotal = totalAssignedData[index]?.y ?? 0;
                                        return customTotal;
                                    },
                                },
                            },
                        },
                    },
                },
            }));




        })
    }

    const parseTime = (timeStr) => {
        const [datePart, timePart] = timeStr.split(' ');
        const [day, month, year] = datePart.split('-').map(num => parseInt(num, 10));
        const [hour, minute] = timePart.split(':').map(num => parseInt(num, 10));

        // We are only interested in the hour and minute part, so let's create a Date object
        const date = new Date(year, month - 1, day, hour, minute);

        // Return the time as milliseconds since 1970, which can be used for x-axis on graphs
        return date.getTime();
    };



    const timeData = {
        series: [
            {
                name: "Completed Tasks",
                data: hoursWiseData ? hoursWiseData.map(item => {
                    const time = parseTime(item.date);
                    return {
                        x: time,  // Timestamp
                        y: item.completed,  // Completed tasks
                        details: item,  // Storing the item data for tooltip
                    };
                }) : [],
            },
        ],
        options: {
            chart: {
                type: "area",
                height: 350,
            },
            stroke: {
                curve: "smooth",  // Ensures smooth line rendering
                width: 5,
            },
            fill: {
                type: "gradient",  // Area chart with gradient fill
                gradient: {
                    shade: "dark",
                    type: "vertical",
                    gradientToColors: ["#ff7f50"],
                    stops: [0, 90, 100],
                },
            },
            xaxis: {
                type: "datetime",  // Time-based x-axis
                labels: {
                    format: " HH:mm",  // Custom date format for labels
                },
            },
            title: {
                text: "",  // No title
                align: "center",
            },
            grid: {
                show: true,  // Enable gridlines
            },
            tooltip: {
                x: {
                    format: " HH:mm",  // Format for the tooltip X-axis (date)
                },
                y: {
                    formatter: (val) => `${val} Tasks Completed`,  // Custom y-axis tooltip format
                },
                custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                    const dataPoint = w.config.series[seriesIndex].data[dataPointIndex];
                    const item = dataPoint.details;
                    return `
                        <div style="padding: 10px;">
                          <strong>Date:</strong> ${item.date}<br/>
                          <strong>Completed:</strong> ${item.completed}<br/>
                          <strong>Total Assigned:</strong> ${item.totalAssigned}<br/>
                          <strong>Pending:</strong> ${item.pending}<br/>
                          <strong>Untouched:</strong> ${item.unTouched}<br/>
                          <strong>Touched:</strong> ${item.touched}
                        </div>
                    `;
                },
            },
        },
    };


    const handlePopup = (show, data) => {
        setselectedDateWisePopup({ show: show, valueDate: data?.date, data: data })
    }

    const handleDesciption = (type, topType, data) => {
        if (type === "touched") {
            return `
            touched Completed : ${data?.[topType]?.touchedCompleted},
            touched Pending : ${data?.[topType]?.touchedPending}
            `
        } else if (type == "untouched") {
            return `
            untouched Completed : ${data?.[topType]?.untouchedCompleted}, 
            untouched Pending : ${data?.[topType]?.untouchedPending}
            `
        }
    }


    return (
        <>

            <div className="Performancetrackermainview container-fluid" style={{ padding: '50px' }}>

                <h5 className='headingh5'>Credit Team</h5>
                <div className="row" style={{ marginBottom: '30px' }}>
                    <div className="col-lg-4 col-sm-6">
                        <div className="boxperformance">
                            <div className="Performancedetailheader" style={{ display: 'flex' }}>
                                <div className="leftside" style={{ width: '100%' }}>

                                    <div className="subleftside" style={{ borderRight: 'none' }}>
                                        <div className="bg-colorbox" style={{ background: 'linear-gradient(135deg, rgb(35, 105, 135), rgb(62, 139, 170))' }}></div>
                                        {employeeData !== '' ? <>
                                            <img className="imgbox" src={profileimg} alt="" />
                                            <h4 className='h4'>{employeeData.name}</h4>
                                            <h6 className='h6'>{employeeData.profile}</h6>
                                        </>
                                            : ""}
                                        <div className="timerbox" style={{ marginTop: employeeData === '' ? '120px' : 'auto' }}>
                                            <div className="clockimg">
                                                <img src={clockimg} width={'72%'} alt="" style={{ marginTop: '10px' }} />
                                            </div>
                                            <div className="timer">
                                                <h6 className='h6'>Average TAT / Lead</h6>
                                                <h6 className='h6' style={{ color: '#000' }}>01:00 hr</h6>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* <div className="rightside">
                                    <div className="subrightside">
                                        <h4 className='h4'>Performance Stats</h4>
                                        {dashboardData?.approvedLeadsPercentage !== undefined ?
                                            <div className="chart">
                                                {dashboardData?.approvedLeadsPercentage !== undefined ? <Pieneedlechart dashboardData={dashboardData} /> : ""}
                                                <div className="box" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-10%' }}>
                                                    <h5 style={{ marginLeft: '5%' }}>{dashboardData?.approvedLeadsPercentage !== undefined ? dashboardData?.approvedLeadsPercentage : 0}%</h5>
                                                    <h5 style={{ marginRight: '15%' }}>{dashboardData.totalPendingLeadsPercentage !== undefined ? dashboardData.totalPendingLeadsPercentage : 0}%</h5>
                                                </div>
                                            </div>
                                            : <div style={{ minHeight: '100px', width: '200px' }}></div>}
                                        <div className="row" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div className="">
                                                <h5 style={{ color: '#486F88', fontSize: '12px', marginTop: '10px' }}>Approved Leads</h5>
                                                <div className="boxtext">

                                                    <h5 className='text-center'>{dashboardData?.approvedLeads !== undefined ? dashboardData?.approvedLeads : 0}</h5>&nbsp;
                                                    
                                                </div>
                                            </div>
                                            <div className="">
                                                <h5 style={{ color: '#486F88', fontSize: '12px', marginTop: '10px' }} >Total Pending</h5>
                                                <div className="boxtext">
                                                    <h5 className='text-center'>{dashboardData?.totalPendingLeads !== undefined ? dashboardData?.totalPendingLeads : 0}</h5>&nbsp;
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            {/* <div className="buttontext">
                                <h5><img src={livechaticon} width={'5%'} alt="" />&nbsp;Start Live Chat</h5>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-8 colrights" style={{ float: 'inline-end' }}>
                        {items.length > 2 ?
                            <div className="boxteammembers">
                                <h5 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>Team Members</h5>
                                <div className="caraousel">
                                    <OwlCarousel
                                        {...optionnews}
                                    >
                                        {items}
                                    </OwlCarousel>

                                </div>
                            </div>
                            :
                            items.length > 0 && items.length <= 2 ?

                                <>
                                    <div className='boxteammembers-credit'>

                                        {operationEmployees && operationEmployees.teamMembers
                                            ? operationEmployees.teamMembers.map((data, i) => (
                                                <div key={i + 1} className="itemcard" onClick={() => getPerformanceData(data)}>
                                                    <div className="subcard">
                                                        <img className="imgbox" src={profileimg} alt="" />
                                                        <h4 className='h4'>{data.name} </h4>
                                                        <h6 className='h6'>{data.profile}</h6>
                                                    </div>
                                                </div>
                                            ))
                                            : ''}
                                    </div>
                                </>
                                : ""
                        }


                    </div>
                </div>

                <hr className='hrtag' />
                <div className="row searchboxrows" style={{ marginBottom: '30px' }}>
                    <div className="col-sm-12 col-xs-12">
                        <DateFilter
                            fromdate={fromdate}
                            todate={todate}
                            onDateChange={handleChange}
                            onApplyFilter={applyfilter}
                            isLoading={loaderState}
                        />
                    </div>
                </div>

                <div className="row rowgraph" style={{ marginBottom: '30px' }}>
                    <div className="col-sm-12" style={{ marginTop: '50px' }}>
                        <div className="operationprocessgraph">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5>Credit Repeat Process</h5>
                                <ToggleButtonGroup
                                    value={chartViewType}
                                    exclusive
                                    onChange={handleChartViewChange}
                                    size="small"
                                    aria-label="chart view toggle"
                                >
                                    <ToggleButton value="funnel" aria-label="funnel view">
                                        Funnel
                                    </ToggleButton>
                                    <ToggleButton value="flowchart" aria-label="flowchart view">
                                        Flowchart
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </div>
                            {chartViewType === 'funnel' ? (
                                <div className="funnelhorizontalgraph">
                                    {loaderState ?
                                        <Loader />
                                        : ""}
                                    <div className="cols">

                                        {loaderState === false && sortedData1?.map((item, index) => {

                                            const currentB = index === 0 ? "20%" : b;
                                            const currentC = index === 0 ? "90%" : c;
                                            const parsedCurrentB = parseInt(currentB);
                                            const parsedCurrentC = parseInt(currentC);
                                            b = 100 - parsedCurrentB;
                                            c = 100 - parsedCurrentC;
                                            let currentB2 = parsedCurrentB + 3;
                                            let currentC2 = parsedCurrentC - 3;
                                            b = currentB2
                                            c = currentC2


                                            return (
                                                <>

                                                    <div className="box-dashboard" key={index} style={{
                                                        borderRadius: index === 0 ? '6px 0px 0px 6px' :
                                                            index === 7 ? '0px 6px 6px 0px' : '0px'
                                                    }} onClick={() => handlefunnelgraphpopup(item.label, item.process)}>
                                                        <h5><img src={usericon} width={'13%'} alt="" />&nbsp;{item.label}</h5>
                                                        <div className="subbox" style={{ clipPath: index === 0 ? `polygon(0 5%, 100% 20%, 100% 80%, 0 95%)` : `polygon(0 ${currentB}%, 100% ${currentB2}%, 100% ${currentC2}%, 0 ${currentC}%)`, background: 'linear-gradient(135deg, rgb(35, 105, 135), rgb(62, 139, 170))' }}>
                                                        </div>
                                                        <h5 className='h5' style={{ color: item.value === 100 ? '#EE9B5E' : '#ffffff' }}>{item.value}</h5>
                                                        <h4>{item.percentage?.toFixed(2)}%</h4>
                                                    </div>
                                                </>
                                            );
                                        })}

                                    </div>
                                </div>
                            ) : (
                                <D3TreeFlowchart
                                    data={sortedData1}
                                    onNodeClick={handlefunnelgraphpopup}
                                    loading={loaderState}
                                    type="credit-team"
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-sm-7 col-xs-12" style={{ marginTop: '50px' }}>
                        <div className="operationprocessgraph">
                            <h5>Progress Datewise</h5>
                            {graphData !== '' ?
                                <ReactApexChart
                                    options={dategraph2}
                                    series={dategraph2.series}
                                    type="rangeBar"
                                    height={395}
                                />
                                : ""}
                        </div>
                    </div>
                    <div className='col-sm-5 col-xs-12' style={{ marginTop: '50px' }}>
                        <div className="operationprocessgraph" style={{ minHeight: '467px', maxHeight: '467px', overflow: 'auto' }}>
                            <h5>Progress Datewise</h5>
                            {/* <div className='phocket-table-new' style={{ overflow: 'auto', height: '380px' }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '6px', textAlign: 'center' }}>Date</th>
                                            <th style={{ padding: '6px', textAlign: 'center' }}>Type</th>
                                            <th style={{ padding: '6px', textAlign: 'center' }}>Touched</th>
                                            <th style={{ padding: '6px', textAlign: 'center' }}>Total Assigned</th>
                                            <th style={{ padding: '6px', textAlign: 'center' }}>Pending</th>
                                            <th style={{ padding: '6px', textAlign: 'center' }}>Untouched</th>
                                            <th style={{ padding: '6px', textAlign: 'center' }}>Completed</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tabledataDate && tabledataDate.length > 0 ? (
                                            tabledataDate.map((entry, i) => (
                                                <React.Fragment key={i}>
                                                    <tr>
                                                        <td rowSpan={2} style={{ textAlign: 'center', minWidth: '150px' }}>{entry.date}</td>
                                                        <td style={{ textAlign: 'center', color: 'green' }}><b>Today</b></td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.today?.touched}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.today?.assigned}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.today?.pending}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.today?.untouched}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.today?.completed}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'center', color: 'red' }}><b>Backlog</b></td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.backlog?.touched}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.backlog?.assigned}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.backlog?.pending}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.backlog?.untouched}</td>
                                                        <td style={{ textAlign: 'center' }}>{entry?.backlog?.completed}</td>
                                                    </tr>
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div> */}
                            <div style={{
                                background: '#ffffff',
                                borderRadius: '8px',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
                                border: '1px solid #e1e4e8',
                                marginTop: '32px'
                            }}>
                                {/* Classic Header */}
                                <div style={{
                                    background: '#f6f8fa',
                                    padding: '20px 24px',
                                    borderBottom: '1px solid #e1e4e8',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <div>
                                        <h3 style={{
                                            margin: 0,
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#24292e',
                                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
                                        }}>
                                            Credit Repeat Summary
                                        </h3>
                                        <p style={{
                                            margin: '4px 0 0 0',
                                            fontSize: '12px',
                                            color: '#586069',
                                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
                                        }}>
                                            Daily metrics and breakdown
                                        </p>
                                    </div>
                                    <div style={{
                                        background: '#ffffff',
                                        padding: '6px 12px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        color: '#586069',
                                        border: '1px solid #d1d5da',
                                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
                                    }}>
                                        {tabledataDate?.length || 0} entries
                                    </div>
                                </div>

                                {/* Compact Table - No Scroll */}
                                <div style={{
                                    overflowX: 'auto',
                                    maxWidth: '100%'
                                }}>
                                    <table style={{
                                        width: '100%',
                                        minWidth: '800px',
                                        borderCollapse: 'collapse',
                                        fontSize: '12px',
                                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
                                        tableLayout: 'fixed'
                                    }}>
                                        <thead>
                                            <tr style={{
                                                background: '#f6f8fa',
                                                borderBottom: '2px solid #d1d5da'
                                            }}>
                                                <th style={{
                                                    padding: '8px 12px',
                                                    textAlign: 'left',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    borderRight: '1px solid #d1d5da',
                                                    width: '15%'
                                                }}>
                                                    Date
                                                </th>
                                                <th style={{
                                                    padding: '8px 8px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    borderRight: '1px solid #d1d5da',
                                                    width: '12%'
                                                }}>
                                                    Type
                                                </th>
                                                <th style={{
                                                    padding: '8px 8px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    borderRight: '1px solid #d1d5da',
                                                    width: '12%'
                                                }}>
                                                    Assigned
                                                </th>
                                                <th style={{
                                                    padding: '8px 8px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    borderRight: '1px solid #d1d5da',
                                                    width: '12%'
                                                }}>
                                                    Touched
                                                </th>
                                                <th style={{
                                                    padding: '8px 8px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    borderRight: '1px solid #d1d5da',
                                                    width: '12%'
                                                }}>
                                                    Untouched
                                                </th>
                                                <th style={{
                                                    padding: '8px 8px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    borderRight: '1px solid #d1d5da',
                                                    width: '12%'
                                                }}>
                                                    Completed
                                                </th>
                                                <th style={{
                                                    padding: '8px 8px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    borderRight: '1px solid #d1d5da',
                                                    width: '12%'
                                                }}>
                                                    Pending
                                                </th>
                                                <th style={{
                                                    padding: '8px 8px',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#24292e',
                                                    fontSize: '11px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                    width: '13%'
                                                }}>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tabledataDate && tabledataDate.length > 0 ? (
                                                tabledataDate.map((row, index) => (
                                                    <React.Fragment key={index}>
                                                        {/* Today Row */}
                                                        <tr style={{
                                                            background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                            borderBottom: '1px solid #e1e4e8',
                                                            transition: 'background-color 0.15s ease'
                                                        }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = '#f3f4f6';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc';
                                                            }}>
                                                            <td
                                                                rowSpan={2}
                                                                style={{
                                                                    padding: '12px 8px',
                                                                    fontWeight: '500',
                                                                    color: '#24292e',
                                                                    borderRight: '1px solid #e1e4e8',
                                                                    verticalAlign: 'middle',
                                                                    background: index % 2 === 0 ? '#f6f8fa' : '#ffffff',
                                                                    fontSize: '11px'
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                    <Calendar style={{
                                                                        width: '14px',
                                                                        height: '14px',
                                                                        color: '#586069',
                                                                        strokeWidth: 2,
                                                                        flexShrink: 0
                                                                    }} />
                                                                    <span style={{
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis'
                                                                    }}>
                                                                        {row?.date}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                verticalAlign: 'middle'
                                                            }}>
                                                                <span style={{
                                                                    background: '#28a745',
                                                                    color: 'white',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '3px',
                                                                    fontSize: '9px',
                                                                    fontWeight: '600',
                                                                    textTransform: 'uppercase',
                                                                    display: 'inline-block'
                                                                }}>
                                                                    Today
                                                                </span>
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontWeight: '500',
                                                                color: '#0366d6',
                                                                fontSize: '12px'
                                                            }}>
                                                                {row?.today?.assigned || 0}
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontSize: '12px'
                                                            }}>
                                                                <CustomTooltip title={handleDesciption("touched", "today", row) || 'No details available'}>
                                                                    <span style={{
                                                                        fontWeight: '600',
                                                                        color: '#f66a0a',
                                                                        cursor: 'help',
                                                                        borderBottom: '1px dotted #f66a0a'
                                                                    }}>
                                                                        {row?.today?.touched || 0}
                                                                    </span>
                                                                </CustomTooltip>
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontSize: '12px'
                                                            }}>
                                                                <CustomTooltip title={handleDesciption("untouched", "today", row) || 'No details available'}>
                                                                    <span style={{
                                                                        fontWeight: '600',
                                                                        color: '#d73a49',
                                                                        cursor: 'help',
                                                                        borderBottom: '1px dotted #d73a49'
                                                                    }}>
                                                                        {row?.today?.untouched || 0}
                                                                    </span>
                                                                </CustomTooltip>
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontWeight: '500',
                                                                color: '#28a745',
                                                                fontSize: '12px'
                                                            }}>
                                                                {row?.today?.completed || 0}
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontWeight: '500',
                                                                color: '#586069',
                                                                fontSize: '12px'
                                                            }}>
                                                                {row?.today?.pending || 0}
                                                            </td>

                                                            <td
                                                                rowSpan={2}
                                                                style={{
                                                                    padding: '12px 4px',
                                                                    textAlign: 'center',
                                                                    borderLeft: '1px solid #e1e4e8',
                                                                    verticalAlign: 'middle',
                                                                    background: index % 2 === 0 ? '#f6f8fa' : '#ffffff'
                                                                }}
                                                            >
                                                                <button
                                                                    onClick={() => handlePopup(true, row)}
                                                                    style={{
                                                                        background: '#0366d6',
                                                                        color: 'white',
                                                                        border: '1px solid #0366d6',
                                                                        borderRadius: '4px',
                                                                        padding: '4px 8px',
                                                                        fontSize: '10px',
                                                                        fontWeight: '500',
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.15s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        margin: '0 auto'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.backgroundColor = '#0256cc';
                                                                        e.currentTarget.style.borderColor = '#0256cc';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = '#0366d6';
                                                                        e.currentTarget.style.borderColor = '#0366d6';
                                                                    }}
                                                                >
                                                                    <Eye style={{ width: 12, height: 12 }} />
                                                                    <span>View</span>
                                                                </button>
                                                            </td>
                                                        </tr>

                                                        {/* Backlog Row */}
                                                        <tr style={{
                                                            background: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                            borderBottom: '1px solid #e1e4e8',
                                                            transition: 'background-color 0.15s ease'
                                                        }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = '#f3f4f6';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc';
                                                            }}>
                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                verticalAlign: 'middle'
                                                            }}>
                                                                <span style={{
                                                                    background: '#fd7e14',
                                                                    color: 'white',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '3px',
                                                                    fontSize: '9px',
                                                                    fontWeight: '600',
                                                                    textTransform: 'uppercase',
                                                                    display: 'inline-block'
                                                                }}>
                                                                    Backlog
                                                                </span>
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontWeight: '500',
                                                                color: '#0366d6',
                                                                fontSize: '12px'
                                                            }}>
                                                                {row?.backlog?.assigned || 0}
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontSize: '12px'
                                                            }}>
                                                                <CustomTooltip title={handleDesciption("touched", "backlog", row) || 'No details available'}>
                                                                    <span style={{
                                                                        fontWeight: '600',
                                                                        color: '#f66a0a',
                                                                        cursor: 'help',
                                                                        borderBottom: '1px dotted #f66a0a'
                                                                    }}>
                                                                        {row?.backlog?.touched || 0}
                                                                    </span>
                                                                </CustomTooltip>
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontSize: '12px'
                                                            }}>
                                                                <CustomTooltip title={handleDesciption("untouched", "backlog", row) || 'No details available'}>
                                                                    <span style={{
                                                                        fontWeight: '600',
                                                                        color: '#d73a49',
                                                                        cursor: 'help',
                                                                        borderBottom: '1px dotted #d73a49'
                                                                    }}>
                                                                        {row?.backlog?.untouched || 0}
                                                                    </span>
                                                                </CustomTooltip>
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                borderRight: '1px solid #e1e4e8',
                                                                fontWeight: '500',
                                                                color: '#28a745',
                                                                fontSize: '12px'
                                                            }}>
                                                                {row?.backlog?.completed || 0}
                                                            </td>

                                                            <td style={{
                                                                padding: '12px 4px',
                                                                textAlign: 'center',
                                                                fontWeight: '500',
                                                                color: '#586069',
                                                                fontSize: '12px'
                                                            }}>
                                                                {row?.backlog?.pending || 0}
                                                            </td>
                                                        </tr>
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" style={{
                                                        padding: '40px 16px',
                                                        textAlign: 'center',
                                                        color: '#586069',
                                                        fontSize: '13px'
                                                    }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                                                            <div style={{ fontSize: '36px', opacity: 0.5 }}>📊</div>
                                                            <div style={{ fontWeight: '500' }}>No data available</div>
                                                            <div style={{ fontSize: '11px', color: '#6a737d' }}>
                                                                Select date range and employee to view performance metrics
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Classic Footer */}
                                <div style={{
                                    background: '#f6f8fa',
                                    padding: '12px 24px',
                                    borderTop: '1px solid #e1e4e8',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                    color: '#586069'
                                }}>
                                    <div>
                                        {/* Credit repeat data updated in real-time */}
                                    </div>
                                    <div>
                                        {/* Last refreshed: {new Date().toLocaleTimeString()} */}
                                    </div>
                                </div>
                            </div>
                            {/* <Accordion disabled
                                sx={{
                                    ".Mui-disabled": {
                                        backgroundColor: '#006c67',
                                        opacity: '1',
                                    },
                                    ".css-1eoq7rj-MuiButtonBase-root-MuiAccordionSummary-root.Mui-disabled": {
                                        opacity: '1',
                                    },
                                    " .MuiAccordionSummary-content": {
                                        display: 'block',
                                        width: '100%'
                                    },
                                    ".css-eqpfi5-MuiAccordionSummary-content": {
                                        margin: '0'
                                    },
                                }}
                            >
                                <AccordionSummary
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Typography component="div">
                                        <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                            <h5 style={{ color: '#fff' }}><b>Date</b></h5>
                                           
                                            <h5 style={{ color: '#fff' }}>View</h5>
                                        </div>

                                    </Typography>
                                </AccordionSummary>
                            </Accordion>
                            <div style={{ height: '350px', overflowY: 'auto' }}>
                                {tabledataDate && tabledataDate.length > 0 ? (
                                    tabledataDate.map((entry, i) => (
                                       
                                         <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px', boxShadow: (tabledataDate?.length == i + 1) ? "none" : '3px 3px 3px 3px rgba(0,0,0,0.5)', background: selectedDateWisePopup?.valueDate == entry?.date ? "#78919c80" : "#fff" }}>
                                            <h5 style={{ color: '#000', margin: '0' }}>{entry?.date}</h5>
                                           
                                            <h5 style={{ color: '#000', margin: '0' }}><i className='fa fa-eye' style={{ cursor: 'pointer' }} onClick={() => handlePopup(true, entry)}></i></h5>
                                        </div>
                                    ))
                                ) : (
                                    ""
                                )}
                            </div> */}
                        </div>

                    </div>
                    {/* {console.log(timeData)} */}
                    {hoursWiseData ?
                        <div className="col-sm-12" style={{ marginTop: '50px' }}>
                            <div className="operationprocessgraph">
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <h5>Progress HoursWise {selectedDate}
                                    </h5>
                                    <div>
                                        <button className={`btn-tab-white ${SelectedHourwiseFilter == "timeframe" ? "active" : ""}`} style={{ borderRadius: "6px", padding: '10px', background: '#dbe9ff', color: '#000', marginRight: '10px' }} onClick={(e) => { setSelectedHourwiseFilter("timeframe"); sendDATA(selectedDateHourwise, "timeframe") }}>Timeframe</button>
                                        <button className={`btn-tab-white ${SelectedHourwiseFilter == "timeframeCumulative" ? "active" : ""}`} style={{ borderRadius: "6px", padding: '10px', background: '#dbe9ff', color: '#000', marginRight: '10px' }} onClick={(e) => { setSelectedHourwiseFilter("timeframeCumulative"); sendDATA(selectedDateHourwise, "timeframeCumulative") }}>Timeframe Cummulative</button>
                                        <button className={`btn-tab-white ${SelectedHourwiseFilter == "backlog" ? "active" : ""}`} style={{ borderRadius: "6px", padding: '10px', background: '#dbe9ff', color: '#000', marginRight: '10px' }} onClick={(e) => { setSelectedHourwiseFilter("backlog"); sendDATA(selectedDateHourwise, "backlog") }}>Backlog</button>
                                    </div>
                                    {/* <select value={SelectedHourwiseFilter} style={{ width: '20%' }} className='form-control' onChange={(e) => { setSelectedHourwiseFilter(e.target.value); sendDATA(selectedDateHourwise, e.target.value) }}>
                                        <option value={"timeframe"}>Timeframe</option>
                                        <option value={"timeframeCumulative"}>Timeframe Cummulative</option>
                                        <option value={"backlog"}>Backlog</option>
                                    </select> */}
                                </div>

                                {/* <ReactApexChart
                                    options={timeData.options}
                                    series={timeData.series}
                                    type="area"
                                    height={350}
                                /> */}
                                <ReactApexChart
                                    options={state.options}
                                    series={state.series}
                                    type="bar"
                                    height={550}
                                />

                            </div>
                        </div>
                        : ""}


                    <div className="col-lg-6 col-xs-12" style={{ marginTop: '50px' }}>
                        <div className="operationprocessgraph">
                            <h5>Performance Analysis</h5>
                            <div className="chart">
                                {!performanceLoader ?
                                    <Areachart areachartData={areachartData} />
                                    : <Loader />}
                            </div>

                        </div>
                    </div>
                    <div className="col-lg-6 col-xs-12" style={{ marginTop: '50px' }}>
                        <div className="operationprocessgraph">
                            <h5>Soft Follow up (Comments) Stats</h5>
                            {!commentLoader ?
                                <div className='funnelchart2'>
                                    <div className="chart">
                                        <ReactApexChart options={options} series={options.series} type="bar" height={235} width={'100%'} />
                                    </div>
                                    <div className='text' style={{ height: "229px", overflow: 'auto' }}>
                                        {nameComment.map((name, index) => (
                                            <h6 key={index}>
                                                {name} - <b>{dataComment[index]}</b>
                                            </h6>
                                        ))}
                                    </div>


                                </div>
                                : <Loader />}
                        </div>
                    </div>
                </div>

                {
                    selectedDateWisePopup?.show == true ?
                        <HandleProgressDateWiseListPopup
                            selectedDateWisePopup={selectedDateWisePopup}
                            handlePopup={handlePopup}
                            emailId={emailId}
                        />
                        : ''}

                {
                    reconcilemodal && tabularData !== '' ?
                        <>
                            <div className="background-blur"></div>
                            <div className={`modal ${reconcilemodal === true ? 'animation-top' : ''}`} style={{ top: '5%' }}>
                                <div className="modal-dialog modal-redesigned">
                                    <div className="modal-content modal-redesigned">
                                        <div className="modal-header modal-redesigned">
                                            <div className="modal-title-section">
                                                <div className="modal-icon">
                                                    <img src={usericon} alt="User" />
                                                </div>
                                                <h5 className="modal-title">{popuplabeltype !== '' ? popuplabeltype : '-'}</h5>
                                            </div>
                                            <div className="modal-actions">
                                                <button type="button" className="modal-close-btn-redesigned" onClick={() => setreconcilemodal(false)}>
                                                    <span className="close-icon">×</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="modal-body modal-redesigned" style={{ overflowX: 'auto', maxHeight: window.innerWidth > 1800 ? '800px' : '450px' }}>
                                            {downloadLoader ? <Loader /> : ""}

                                            <div className='credit-table tablesecond' >
                                                <table className='table2 table-redesigned'>
                                                    <thead>
                                                        <tr className="thead-className">

                                                            <th className="">
                                                                Currently Assigned
                                                            </th>
                                                            <th className="">
                                                                Application Id
                                                            </th>
                                                            <th className="">
                                                                Name
                                                            </th>

                                                            <th className="">
                                                                Loan Amount
                                                            </th>
                                                            <th className="">
                                                                Loan status
                                                            </th>
                                                            <th className="">
                                                                Applied At
                                                            </th>
                                                            <th className="">
                                                                Touched On
                                                            </th>
                                                            <th className="">
                                                                Completed On
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody style={{ fontWeight: '400' }}>
                                                        {tabularData !== '' && tabularData !== null && tabularData?.length > 0 && tabularData?.map((data, i) => {
                                                            return (
                                                                <tr key={i}>

                                                                    <td scope="col" style={{ backgroundColor: data?.currentlyAssigned == true ? '#19d71959' : "#f03d3d99", color: '#000' }}>
                                                                        {data?.currentlyAssigned == true ? "Yes" : "No" || "-"}
                                                                    </td>
                                                                    <td scope="col">
                                                                        {data?.applicationId || "-"}
                                                                    </td>
                                                                    <td scope="col">
                                                                        {data?.name || "-"}
                                                                    </td>

                                                                    <td scope="col" >
                                                                        ₹ {data?.loanAmount || "-"}
                                                                    </td>
                                                                    <td scope="col" >
                                                                        {data?.loanStatus || "-"}
                                                                    </td>
                                                                    <td scope="col" >
                                                                        {data?.assignedAt || "-"}
                                                                    </td>
                                                                    <td scope="col" >
                                                                        {data?.touchedOn || "-"}
                                                                    </td>
                                                                    <td scope="col" >
                                                                        {data?.completedOn || "-"}
                                                                    </td>

                                                                </tr>
                                                            )
                                                        })}


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </>
                        : ""
                }
            </div>
        </>
    )
}
export default PerformanceDashboard;


function Card({ img, txt, operationEmployees }) {

    return (
        <>
            {operationEmployees && operationEmployees.teamMembers ? operationEmployees.teamMembers.map((data) => {
                return (
                    <div className="itemcard">
                        <div className="subcard">
                            <img className="imgbox" src={img} alt="" />
                            <h4 className='h4'>{data.name} </h4>
                            <h6 className='h6'>{data.profile}</h6>
                        </div>
                    </div>
                )
            })

                : ""}
        </>
    )
}

const HandleProgressDateWiseListPopup = ({ selectedDateWisePopup, handlePopup, emailId }) => {
    // const tenant = useSelector((state) => state.tenant.activeTenant);
    // Temporarily hardcoded tenant to avoid Redux context issues
    const tenant = "default";
    const topValue = (type) => {
        if (type == "TODAY") {
            return "today"
        } else if (type == "BACKLOG") {
            return "backlog"
        }
    }

    const handleKeyvalue = {
        "assigned": "ASSIGNED",
        "previouslyTouched": "PREVIOUSLY_TOUCHED",
        "previouslyTouchedCompleted": "PREVIOUSLY_TOUCHED_COMPLETED",
        "previouslyTouchedPending": "PREVIOUSLY_TOUCHED_PENDING",
        "touched": "TOUCHED",
        "touchedCompleted": "TOUCHED_COMPLETED",
        "touchedPending": "TOUCHED_PENDING",
        "untouched": "UNTOUCHED",
        "untouchedCompleted": "UNTOUCHED_COMPLETED",
        "untouchedPending": "UNTOUCHED_PENDING",
        "completed": "COMPLETED",
        "pending": "PENDING"
    }
    const handleKeyvalueReverse = {
        "ASSIGNED": "assigned",
        "PREVIOUSLY_TOUCHED": "previouslyTouched",
        "PREVIOUSLY_TOUCHED_COMPLETED": "previouslyTouchedCompleted",
        "PREVIOUSLY_TOUCHED_PENDING": "previouslyTouchedPending",
        "TOUCHED": "touched",
        "TOUCHED_COMPLETED": "touchedCompleted",
        "TOUCHED_PENDING": "touchedPending",
        "UNTOUCHED": "untouched",
        "UNTOUCHED_COMPLETED": "untouchedCompleted",
        "UNTOUCHED_PENDING": "untouchedPending",
        "COMPLETED": "completed",
        "PENDING": "pending"
    }

    const itemsPerPage = 10;
    const [loaderState, setloaderState] = useState(false)
    const [activeListType, setactiveListType] = useState("TODAY")
    const [activeTab, setActiveTab] = useState("ASSIGNED")
    const [handleSelect, setHandleSelect] = useState("TODAY")
    const [apiData, setApiData] = useState([])
    const [currentPage, setcurrentPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [paginatedData, setPagintedData] = useState([])
    const [payload, setPayload] = useState({
        "activityType": "ASSIGNED",
        "timeFrame": "TODAY"
    })

    const handleActiveTab = (e) => {
        setActiveTab(e)
        const obj = {
            ...payload,
            "activityType": e
        }
        setPayload(obj)
        getEmployeeLeadActivityFn(obj)
    }
    const handleActiveListType = (type) => {
        setactiveListType(type)
        const obj = {
            ...payload,
            "timeFrame": type
        }
        setPayload(obj)
        getEmployeeLeadActivityFn(obj)
    }

    const handleNameTabs = (value) => {
        if (value == "assigned") {
            return "Assigned"
        } else if (value == "previouslyTouched") {
            return "Previously Touched"
        } else if (value == "previouslyTouchedCompleted") {
            return "Previously Touched Completed"
        } else if (value == "previouslyTouchedPending") {
            return "Previously Touched Pending"
        } else if (value == "touched") {
            return "Touched"
        } else if (value == "touchedCompleted") {
            return "Touched Completed"
        } else if (value == "touchedPending") {
            return "Touched Pending"
        } else if (value == "untouched") {
            return "Untouched"
        } else if (value == "untouchedCompleted") {
            return "Untouched Completed"
        } else if (value == "untouchedPending") {
            return "Untouched Pending"
        } else if (value == "completed") {
            return "Completed"
        } else if (value == "pending") {
            return "Pending"
        }
    }

    useEffect(() => {
        getEmployeeLeadActivityFn(payload)
    }, [])

    const getEmployeeLeadActivityFn = (data) => {
        const obj = {
            ...data,
            "dateStr": selectedDateWisePopup?.valueDate,
            "assignedTo": emailId,
        }
        setloaderState(true)
        getEmployeeLeadActivity(obj, callback => {
            setloaderState(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setTotalPage(callback?.data?.length)
                setApiData(callback?.data)
                setcurrentPage(1)
                handleFilteration(1, callback?.data)
            } else {
                setApiData([])
                setPagintedData([])
            }
        })
    }

    const handleFilteration = (currentPage, data) => {
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setPagintedData(currentItems)
    }

    const handlePageChange = (event, value) => {
        setcurrentPage(value);
        handleFilteration(value, apiData)
    };


    return (
        <>
            <div className="background-blur"></div>
            <div className={`modal ${selectedDateWisePopup?.show === true ? 'animation-top' : ''}`} style={{ top: '3%' }}>
                <div className="modal-dialog modal-redesigned modal-wide" style={{ width: '85%' }}>
                    <div className="modal-content modal-redesigned">
                        <div className="modal-header modal-redesigned">
                            <div className="modal-title-section">
                                <div className="modal-icon modal-icon-calendar">
                                    <i className="fa fa-calendar"></i>
                                </div>
                                <h4 className="modal-title">Date: {selectedDateWisePopup?.valueDate || ""}</h4>
                            </div>
                            <div className="modal-actions">
                                <button type="button" className="modal-close-btn-redesigned" onClick={() => handlePopup(false, "")}>
                                    <span className="close-icon">×</span>
                                </button>
                            </div>
                            {loaderState ? <Loader /> : ""}
                        </div>
                        <div className="modal-body modal-redesigned" style={{ overflowX: 'auto', maxHeight: window.innerWidth > 1800 ? "900px" : '650px' }}>

                            <div className="Tabs tabs-redesigned" style={{ display: 'flex' }}>
                                <div className="tabs" style={{
                                    width: "calc(100%/2)", padding: '10px', margin: '20px 20px 10px 0px', borderRadius: '6px'
                                    , background: 'rgb(255, 226, 230)',
                                    boxShadow: 'rgb(249, 190, 198) 4px 4px 0px 2px'
                                }} >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h5 style={{ fontWeight: '600' }}>Assigned Today</h5>
                                        <i style={{
                                            cursor: 'pointer',
                                            color: activeListType === "TODAY" ? "#006c67" : "#000"
                                        }}
                                            className={`fa ${activeListType === "TODAY" ? "fa-eye" : "fa-eye-slash"} `}
                                            onClick={() => handleActiveListType("TODAY")}></i>
                                    </div>
                                    <h2><b>{selectedDateWisePopup?.data?.today?.assigned}</b></h2>
                                </div>
                                <div className="tabs" style={{
                                    width: "calc(100%/2)", padding: '10px', margin: '20px 20px 10px 0px', borderRadius: '6px'
                                    , background: 'rgb(220, 252, 231)',
                                    boxShadow: 'rgb(139, 211, 164) 4px 4px 0px 2px'
                                }} >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h5 style={{ fontWeight: '600' }}>Backlog Assigned</h5>
                                        <i style={{
                                            cursor: 'pointer',
                                            color: activeListType === "BACKLOG" ? "#006c67" : "#000"
                                        }} className={`fa ${activeListType === "BACKLOG" ? "fa-eye" : "fa-eye-slash"} `} onClick={() => handleActiveListType("BACKLOG")}></i>
                                    </div>
                                    <h2><b>{selectedDateWisePopup?.data?.backlog?.assigned}</b></h2>
                                </div>
                                {/* <div className="tabs" style={{
                                    width: "calc(100%/3)", padding: '10px', margin: '20px 20px 10px 0px', borderRadius: '6px'
                                    , background: "rgb(244, 232, 255)",
                                    boxShadow: "rgb(175, 133, 213) 4px 4px 0px 2px"
                                }} >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <h5 style={{ fontWeight: '600' }}>Assignment Today</h5>
                                        <i style={{
                                            cursor: 'pointer',
                                            color: activeListType === "TODAY" ? "#006c67" : "#000"
                                        }} className={`fa ${activeListType === "TODAY" ? "fa-eye" : "fa-eye-slash"} `} onClick={() => handleActiveListType("TODAY")}></i>
                                    </div>
                                    <h2><b>{selectedDateWisePopup?.data?.assignedToday}</b></h2>
                                </div> */}
                            </div>

                            <div className='row' style={{ marginTop: '25px' }}>
                                <div className="col-sm-2 col-xs-12">
                                    <label htmlFor="">Filter</label>
                                    <select className='form-control' value={activeListType} onChange={(e) => { handleActiveListType(e.target.value); setHandleSelect(e.target.value) }}>
                                        <option value={"TODAY"}>Today</option>
                                        <option value={"BACKLOG"}>Backlog</option>
                                    </select>

                                </div>

                                <div className="col-sm-10 col-xs-12">
                                    <div style={{ borderLeft: '1px solid #000', borderRight: '1px solid #000', padding: '0 10px', marginTop: '22px' }}>
                                        <div style={{ display: 'flex', overflowX: 'auto', scrollbarWidth: 'thin' }}>
                                            {
                                                selectedDateWisePopup?.data?.[topValue(handleSelect)] && Object.keys(selectedDateWisePopup?.data?.[topValue(handleSelect)])?.length > 0 ?
                                                    Object.entries(selectedDateWisePopup?.data?.[topValue(handleSelect)])?.map(([key, pair], id) => {
                                                        // console.log("key", key)
                                                        return (
                                                            <div key={id} style={{
                                                                //  background:  activeTab === handleKeyvalue[key] ? CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?  "linear-gradient(150deg, #006c67 50%, rgb(215, 215, 215) 100%)" : "linear-gradient(150deg, #267dff 50%, rgb(215, 215, 215) 100%)" : 'linear-gradient(135deg, rgba(173, 75, 75, 0.1) 0%, rgb(215, 215, 215) 100%)',
                                                                background: activeTab === handleKeyvalue[key] ? "linear-gradient(150deg, #006c67 50%, rgb(215, 215, 215) 100%)" : 'linear-gradient(135deg, rgba(173, 75, 75, 0.1) 0%, rgb(215, 215, 215) 100%)',
                                                                borderRadius: '6px', padding: '13.5px', cursor: 'pointer',
                                                                marginRight: '10px',
                                                                color: activeTab === handleKeyvalue[key] ? "#fff" : '#000'
                                                            }}
                                                                onClick={() => handleActiveTab(handleKeyvalue[key])}
                                                            >
                                                                <h5 style={{ margin: '0', fontSize: '14px', textAlign: 'center', whiteSpace: 'nowrap' }}>{handleNameTabs(key)} : <b>{pair}</b></h5>

                                                            </div>
                                                        )
                                                    })
                                                    : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr style={{ margin: '15px 0' }} />

                            <div className='credit-table tablesecond' >
                                {
                                    paginatedData && paginatedData?.length > 0 ?
                                        <>
                                            <div style={{ height: window.innerWidth > 1800 ? '550px' : '300px', overflowY: 'auto' }}>
                                                <table className=' table2'>
                                                    <thead style={{ top: '0', position: 'sticky' }}>
                                                        <tr className="thead-className">
                                                            <th className="">
                                                                Application Id
                                                            </th>
                                                            <th className="">
                                                                Name
                                                            </th>
                                                            <th className="">
                                                                Email Id
                                                            </th>
                                                            <th className="">
                                                                Mobile Number
                                                            </th>
                                                            <th className="">
                                                                Status
                                                            </th>

                                                            <th className="">
                                                                Loan Amount
                                                            </th>
                                                            <th className="">
                                                                Loan Apply Date
                                                            </th>
                                                            <th className="">
                                                                Loan From
                                                            </th>

                                                        </tr>
                                                    </thead>

                                                    <tbody style={{ fontWeight: '400' }}>
                                                        {paginatedData?.map((data, i) => {
                                                            return (
                                                                <tr key={i}>

                                                                    <td scope="col">
                                                                        {data?.applicationId}
                                                                    </td>
                                                                    <td scope="col">
                                                                        {data?.userName}
                                                                    </td>
                                                                    <td scope="col">
                                                                        {data?.emailId}
                                                                    </td>
                                                                    <td scope="col">
                                                                        {data?.mobileNumber}
                                                                    </td>
                                                                    <td scope="col">
                                                                        {data?.applicationStatus}
                                                                    </td>

                                                                    <td scope="col" >
                                                                        ₹ {data?.loanAmount}
                                                                    </td>
                                                                    <td scope="col" >
                                                                        {data?.loanApplyDate}
                                                                    </td>
                                                                    <td scope="col" >
                                                                        {data?.loanFrom}
                                                                    </td>


                                                                </tr>
                                                            )
                                                        })}


                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style={{ marginTop: '10px', float: "right" }}>
                                                <Pagination shape="rounded"
                                                    count={Math.ceil(totalPage / itemsPerPage)}
                                                    page={currentPage}
                                                    onChange={handlePageChange}
                                                    color="primary"
                                                />
                                            </div>
                                        </>
                                        :
                                        <div style={{ textAlign: 'center' }}>
                                            <img src={NoData} width={"30%"} />
                                        </div>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}